export default {
  errorName: "Title must not be empty.",
  errorSymbol: "Symbol must not be empty.",
  errorDescription: "Description must not be empty.",
  errorType: "Type must not be empty.",
  errorUpdateProfile: "At least one field should be updated",
  errorDate: "Date must not be empty.",
  errorCategory: "Category must not be empty.",
  errorAmount: "Amount must not be empty.",
  errorCurrency: "Currency must not be empty.",
  enterName: "Enter title",
  enterSymbol: "Enter symbol",
  enterDescription: "Enter description",
  enterType: "Choose type",
  enterCategory: "Choose category",
  enterAmount: "Enter amount",
  enterCurrency: "Choose currency",
  enterDate: "Choose date",
  add: "Add",
  delete: "Delete",
  edit: "Edit",
  export: "Export",
  filters: "Filters",
  actions: "Actions",
  close: "Close",
  yes: "Yes",
  no: "No",
  currency: "Currency",
  currencyPageSubtitle: "Here you can setup currencies you want to use in the system",
  name: "Title",
  firstName: "First Name",
  lastName: "Last Name",
  symbol: "Symbol",
  description: "Description",
  type: "Type",
  category: "Category",
  calculateForGross: "Include in calculation for GROSS profit",
  calculateForNet1: "Include in calculation for Profit 1",
  calculateForNet2: "Include in calculation for Profit 2",
  confirmationModalTitle: "Confirmation",
  confirmationModalMessage: "Are you sure you want to proceed with the action?",
  save: "Save",
  income: "Income",
  incomeType: "Income type",
  incomeTypePageSubtitle: "Here you can setup income types you want to use in the system",
  incomeCategory: "Income category",
  incomeCategoryPageSubtitle: "Here you can setup income categories you want to use in the system",
  cost: "Cost",
  costType: "Cost type",
  costTypePageSubtitle: "Here you can setup cost types you want to use in the system",
  costCategory: "Cost category",
  costCategoryPageSubtitle: "Here you can setup cost categories you want to use in the system",
  dashboard: "Dashboard",
  dashboardPageSubtitle: "Overview of your entire business",
  incomes: "Incomes",
  totalIncomes: "Total Incomes",
  averageIncomes: "Average Incomes",
  viewIncomes: "View Incomes",
  incomesDistribution: "Incomes Distribution",
  incomesDistributionByType: "Incomes Distribution (by type)",
  incomesDistributionByCategory: "Incomes Distribution (by category)",
  incomesPageSubtitle: "Overview of your income",
  costs: "Costs",
  totalCosts: "Total Costs",
  averageCosts: "Average Costs",
  viewCosts: "View Costs",
  costsDistribution: "Costs Distribution",
  costsDistributionByType: "Costs Distribution (by type)",
  costsDistributionByCategory: "Costs Distribution (by category)",
  costsPageSubtitle: "Overview of your costs",
  selectPlaceholder: "Choose",
  account: "Account",
  accountDetails: "Account Details",
  security: "Security",
  email: "Email",
  changePassword: "Change Password",
  oldPassword: "Old Password",
  newPassword: "New Password",
  confirmPassword: "Confirm Password",
  enterOldPassword: "Enter old password",
  enterNewPassword: "Enter new password",
  enterConfirmPassword: "Confirm new password",
  errorOldPassword: "Old password must not be empty.",
  errorNewPassword: "New password must not be empty.",
  errorConfirmPassword: "Confirmation of the new password must not be empty.",
  errorConfirmMismatchPassword: "Confirm and new password mismatch.",
  apiBadRequestError: "Please check if sent parameters are in the proper format.",
  apiNotAuthorizedError: "Please login again.",
  apiForbiddenError: "You don't have the permission to access the requested resource.",
  apiNotFoundError: "Requested resource not found.",
  apiConflictError: "You cannot perform this action on the selected resource.",
  apiInternalServerError: "An unexpected error has occurred. Please try again later.",
  apiLoginError: "Invalid username or password.",
  resetPasswordLinkError: "Reset password link is corrupted.",
  info: "Info",
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",
  currentMonth: "Current month",
  success: "Success",
  error: "Error",
  profileUpdateSuccess: "Profile is successfully updated.",
  passwordUpdateSuccess: "Password is successfully updated.",
  amount: "Total amount",
  date: "Date",
  searchCosts: "Search costs",
  search: "Search",
  resetSearch: "Reset search",
  costsSearchResults: "Found {0} costs from {1} to {2}",
  total: "Total: {0}",
  searchIncomes: "Search incomes",
  incomesSearchResults: "Found {0} incomes from {1} to {2}",
  net1: "Net 1",
  net2: "Net 2",
  viewReport: "View Report",
  reviewForPeriod: "Review for period from {0} to {1}",
  noData: "No data",
  reports: "Reports",
  quarterlyReport: "Quarterly Report",
  quarterlyReportSubtitle: "Compare incomes and costs quarterly",
  comparativeReport: "Comparative Report",
  comparativeReportSubtitle: "Compare incomes and costs for any two months",
  login: "Login",
  logout: "Logout",
  enterEmail: "Enter email address",
  errorEmail: "Email address must not be empty.",
  password: "Password",
  enterPassword: "Enter password",
  errorPassword: "Password must not be empty.",
  forgotPassword: "Forgot Password?",
  passwordRecovery: "Password Recovery",
  passwordForgotten: "Forgot Password",
  resetPassword: "Reset password",
  returnToLogin: "Return to login",
  forgotPasswordDescription: "Enter your email address and we will send you a link to reset your password.",
  forgotPasswordEmailSent: "Email containing reset password link is sent.",
  forgotPasswordRequest: "Send request",
  byType: "By Type",
  byCategory: "By Category",
  quarter1: "1st Quarter",
  quarter2: "2nd Quarter",
  quarter3: "3rd Quarter",
  quarter4: "4th Quarter",
  overview: "Overview",
  inDetail: "In Detail",
  average: "Average",
  permissionsAlert: "You do not have permissions to access this page, please contact your administrator.",
  percentageOfIncome: "Percentage of Income",
  percentageOfCost: "Percentage of Cost",
  nominalValue: "Nominal Value",
  defaultIncomes: "Default Incomes",
  otherIncomes: "Other Incomes",
};
